export const breakoutResizableNodes: string[] = [
	'expand',
	'layoutSection',
	'codeBlock',
	'syncBlock',
	'bodiedSyncBlock',
];
